// @flow
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../messages';
import styles from './styles';

type Props = {
  where: ?string,
  wrongWhat: string,
  correctWhat: string,
  url?: ?string,
};

function DidYouMeanBanner({ wrongWhat, correctWhat, where, url }: Props) {
  return (
    <div className="relatedResultsnoResults" data-test="dym">
      <p className="oldResultsElement">
        <FormattedHTMLMessage {...messages.noResults} values={{ '%s': wrongWhat }} />
      </p>
      <p className="newResultsElement">
        <span>
          <FormattedMessage {...messages.didYouMeanTitle} />
        </span>{' '}
        <a href={url}>{`${correctWhat} ${where || ''}`}</a>
      </p>
      <style jsx>{styles}</style>
    </div>
  );
}

DidYouMeanBanner.defaultProps = {
  url: null,
};

export default DidYouMeanBanner;



// WEBPACK FOOTER //
// ./app/Serp/components/DidYouMeanBanner/index.js